import {
  SET_COMMENTS,
  SET_COMMENTS_LOADING,
  LOAD_MORE_COMMENTS,
  SET_EDITED_COMMENT,
  SET_ENTITY_ID,
  SET_ERROR,
  SET_PAGE,
  SET_IS_MESSAGE_BEING_EDITED,
  SET_MAX_PAGE,
  RESET_COMMENTS_DATA,
  SET_CURRENT_COMMENT,
} from '../../actions/commentsActions/actionTypes';

const defaultState = {
  entityId: null,
  comments: { isLoading: false, data: [] },
  page: 0,
  maxPage: 0,
  editedComment: {
    id: null,
    message: null,
    attachments: [],
  },
  currentComment: {
    message: null,
    attachments: { images: [], files: [] },
  },
  isCommentBeingEdited: false,
  error: { isError: false, message: '' },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_COMMENTS:
      return {
        ...state,
        comments: { isLoading: false, data: action.payload },
        isCommentBeingEdited: false,
      };
    case LOAD_MORE_COMMENTS:
      return {
        ...state,
        comments: {
          isLoading: false,
          data: [...state.comments.data, ...action.payload],
        },
        isCommentBeingEdited: false,
      };
    case SET_COMMENTS_LOADING:
      return {
        ...state,
        comments: { ...state.comments, isLoading: action.payload },
      };
    case SET_EDITED_COMMENT:
      return {
        ...state,
        editedComment: action.payload,
      };
    case SET_CURRENT_COMMENT:
      return {
        ...state,
        currentComment: action.payload,
      };
    case SET_IS_MESSAGE_BEING_EDITED:
      return {
        ...state,
        isCommentBeingEdited: action.payload,
      };
    case SET_ENTITY_ID:
      return {
        ...state,
        entityId: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case SET_MAX_PAGE:
      return {
        ...state,
        maxPage: action.payload,
      };
    case RESET_COMMENTS_DATA:
      return defaultState;
    default:
      return state;
  }
};
